import React from "react";
import { Avatar, Box, createStyles, IconButton, Theme } from '@material-ui/core';
import { Participant } from "../../core/api/model";
import CustomIcon from "../../core/custom-icon";
import { DashboardPanelListItem } from "../DashboardPanel";
import { makeStyles } from "@material-ui/core/styles";

export interface DashboardExpertsListItemProps {
  expert: Participant;
  deleteExpert: (expert: Participant) => void;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    deleteButton: {
      [theme.breakpoints.down('sm')]: {
        color: theme.palette.error.main
      },
      '&:hover': {
        color: theme.palette.error.main
      }
    }
  }),
);

export const DashboardExpertsListItem = (props: DashboardExpertsListItemProps) => {
  const classes = useStyles();

  return (

    <DashboardPanelListItem headline={`${props.expert.partName} ${props.expert.partSurname}`}
                            imageSlot={
                                <Avatar alt={`${props.expert.partName} ${props.expert.partSurname}`}
                                        src={props.expert.partPic?.url}>
                                <CustomIcon iconname='person'
                                            viewBox='0 0 16 16'
                                            fontSize='small'
                                />
                              </Avatar>
                            }
                            contentSlot={
                              <Box display='flex' component='p' mt={0.9} mb={0}>
                                <CustomIcon iconname='date'
                                            viewBox='0 0 16 16'
                                            fontSize='small'
                                />
                                <Box component='span' ml={1}>
                                  {props.expert.partFunction}
                                </Box>
                              </Box>
                            }
                            actionsSlot={
                              <IconButton aria-label=''
                                          color='primary'
                                          className={classes.deleteButton}
                                          onClick={() => props.deleteExpert( props.expert )}
                              >
                                <CustomIcon iconname='delete' />
                              </IconButton>
                            }
                            contentBelowImage />
  )
};
